import PayOrderRepository from '../../domain/repositories/PayOrderRepository';
import PayOrderDataStore from '../datastores/PayOrderDataStore';
import PayOrderDataStoreFactory from '../factories/PayOrderRequestDataStoreFactory';

export default class PayOrderDataRepository implements PayOrderRepository {
  register(
    code: string,
    orderId: string,
    transactionId: string,
    email: string,
    payMethod: string,
    brand: string,
    message: string
  ) {
    const payOrderRequestDataStore: PayOrderDataStore =
      PayOrderDataStoreFactory.create();
    return payOrderRequestDataStore.register(
      code,
      orderId,
      transactionId,
      email,
      payMethod,
      brand,
      message
    );
  }
}
